<template>
	<transition-group
		tag="div"
		name="fade" 
		ref="messge"
		@enter="enter" 
		@leave="leave" 
		class="messgae-container">
		<div 
			:key="item.id"
			v-text="item.text"
			:style="item.style"
			:message-id="item.id"
			class="message-content"
			v-for="item in messageQueue">
		</div>
	</transition-group>
</template>

<script>
	export default {
		name: 'messgae',
		data() {
			return {
				messageTotal: 1,
				messageQueue: [],
				messageTimer: null
			}
		},
		methods: {
			show(text = '') {
				text = String(text);
				if (text) {
					let height = 0;
					let style = 'top: 20px;';
					let remove = this.remove(text);
					let id = String(this.messageTotal);
					if (this.messageQueue.length) {
						let top = this.messageQueue.reduce((total, pre) => total + pre.height, 0) + (this.messageQueue.length + 1) * 20;
						style = `top: ${top}px;`;
					}
					this.messageQueue.push({
						id,
						text,
						style,
						height,
						remove
					});
					this.messageTotal += 1;
					if (this.messageTimer === null) {
						this.messageTimer = setInterval(() => this.hide(), 500);
					}
				}
			},
			hide() {
				const newTime = Date.now();
				for (let i = 0, length = this.messageQueue.length; i < length; i++) {
					if (newTime > this.messageQueue[i].remove) {
						this.messageQueue.splice(i, 1);
						length -= 1;
						i -= 1;
					}
				}
				if (this.messageQueue.length === 0) {
					clearInterval(this.messageTimer);
					this.messageTimer = null;
				}
			},
			enter(element) {
				const id = element.getAttribute('message-id');
				const index = this.messageQueue.findIndex(v => v.id === id);
				this.messageQueue[index]['height'] = element.offsetHeight;
				this.leave();
			},
			leave() {
				let top = 20;
				for (let i = 0, length = this.messageQueue.length; i < length; i++) {
					top += i ? (20 + this.messageQueue[i - 1].height) : 0;
					this.$set(this.messageQueue[i], 'style', `top: ${top}px;`);
				}
			},
			remove(text = '') {
				const remove = Date.now();
				const string = text.replace(/\s+/g, '');
				if (string.length < 10) {
					return remove + 4000;
				}
				if (string.length < 15) {
					return remove + 5000;
				}
				return remove + 5000 +  Math.floor(string.length / 15) * 1000;
			}
		}
	}
</script>

<style scoped lang="less">
	.messgae-container{
		.fade-enter, .fade-leave-to{
			opacity: 0;
			margin-top: -50px;
		}
		.fade-enter-to, .fade-leave{
			opacity: 1;
			margin-top: 0;
		}
		.message-content{
			width: calc(100vw - 60px);
			position: fixed;
			top: 20px;
			left: 50%;
			padding: 10px;
			color: #FFFFFF;
			z-index: 10000;
			max-width: 480px;
			min-width: 230px;
			overflow: hidden;
			font-size: 1.6rem;
			line-height: 2rem;
			border-radius: 2px;
			pointer-events: none;
			word-wrap: break-word;
			transition: all 500ms;
			transform: translateX(-50%);
            // background-color: rgba(65, 70, 110, 0.7);
			// background-color: rgba(45, 62, 80, 0.8);
            background-color: #41466E;
			box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		}
	}
</style>
